import apiUrlProvider, {
  VOUCHER_APPLY,
  VOUCHER_CLEAR,
  VOUCHER_PAY,
} from 'constants/api-endpoints';
import { fetchPost, fetchPut } from 'utils/services/fetch';

export interface VoucherApplyResponse {
  message: string;
  voucher: {
    code: string;
    type: string;
    discountAmount: number;
    transactionId: string;
    newAmount: number;
    coversFullAmount: boolean;
  };
}

export const requestApplyVoucher = (token: string, code: string): Promise<VoucherApplyResponse> => {
  const url = apiUrlProvider.get(VOUCHER_APPLY);
  return fetchPost(url, { code }, { isAuth: true, token });
};

export const requestClearVoucher = (token: string): Promise<{ message: string }> => {
  const url = apiUrlProvider.get(VOUCHER_CLEAR);
  return fetchPut(url, {}, { isAuth: true, token });
};

export const requestPayWithVoucher = (
  token: string,
  tipPercentage = 0,
): Promise<{ message: string; success: boolean }> => {
  const url = apiUrlProvider.get(VOUCHER_PAY);
  return fetchPost(url, { tip_percentage: tipPercentage }, { isAuth: true, token });
};
